import "./Notifications.scss";

import React, { useEffect, useRef, useState } from "react";
import { IoNotificationsOutline } from "react-icons/io5";
import Heading from "ui/build/components/Heading/Heading";
import Para from "ui/build/components/Para/Para";

import { t } from "../../../utils/ResourceUtils";
import NotificationItem from "./NotificationItem";

const NotificationPopOver = ({
  notificationData,
  unreadCount,
  callUpdate,
  onToggle,
  onLoadMore,
  isLoadingMore,
  hasNextPage,
}) => {
  const [showPopOver, setShowPopOver] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const popoverRef = useRef(null);
  const notificationsListRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setShowPopOver(false);
        if (onToggle) onToggle(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onToggle]);

  useEffect(() => {
    const handleScroll = () => {
      if (!notificationsListRef.current || !hasNextPage || isLoadingMore) return;

      const { scrollTop, scrollHeight, clientHeight } = notificationsListRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        onLoadMore();
      }
    };

    const listElement = notificationsListRef.current;
    if (listElement) {
      listElement.addEventListener("scroll", handleScroll);
      return () => listElement.removeEventListener("scroll", handleScroll);
    }
  }, [hasNextPage, isLoadingMore, onLoadMore]);

  const togglePopOver = () => {
    const newState = !showPopOver;
    setShowPopOver(newState);
    if (onToggle) onToggle(newState);
  };

  const filteredNotifications = notificationData.filter((notification) => {
    if (activeTab === "unread") {
      return notification.status === "unDelivered";
    }
    return true;
  });

  return (
    <div className="notification-wrapper">
      <button type="button" className="notification-icon-container" onClick={togglePopOver}>
        <IoNotificationsOutline size="25px" style={{ color: "#16617d" }} />
        {unreadCount > 0 && <span className="notification-counter">{unreadCount}</span>}
      </button>

      {showPopOver && (
        <div className="custom-popover" ref={popoverRef}>
          <div className="notification-body">
            <div className="header-fixed pt-2">
              <div className="notification-header">
                <Heading variant="h5">{t("cm.notifications")}</Heading>
                <div className="notification-header-actions">
                  {unreadCount > 0 && (
                    <div className="notification-badge">
                      {unreadCount} {t("cm.new")}
                    </div>
                  )}
                </div>
              </div>

              <div className="notification-tabs">
                <button
                  className={`tab-button ${activeTab === "all" ? "active" : ""}`}
                  onClick={() => setActiveTab("all")}
                >
                  {t("cm.all")}
                </button>
                <button
                  className={`tab-button ${activeTab === "unread" ? "active" : ""}`}
                  onClick={() => setActiveTab("unread")}
                >
                  {t("cm.unread")}
                  {unreadCount > 0 && <span className="tab-count">{unreadCount}</span>}
                </button>
              </div>
            </div>

            {filteredNotifications?.length > 0 ? (
              <div className="notifications-list" ref={notificationsListRef}>
                {filteredNotifications.map((notify) => (
                  <NotificationItem key={notify?.notificationId} notify={notify} callUpdate={callUpdate} />
                ))}
                {isLoadingMore && (
                  <div className="loading-more">
                    <Para>{t("cm.loading_more_notifications")}</Para>
                  </div>
                )}
                {!hasNextPage && filteredNotifications.length > 0 && (
                  <div className="no-more-notifications">
                    <Para>{t("cm.no_new_notifications")}</Para>
                  </div>
                )}
              </div>
            ) : (
              <div className="no-notifications">
                <Para>
                  {activeTab === "unread" ? t("cm.no_unread_notifications") : t("cm.no_notification_available")}
                </Para>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationPopOver;
